import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Slider from 'react-slick';
import Navigation from '../components/navigation';
import Footer from '../components/footer';
import './aktuelle.css';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';

const truncateText = (text, maxLength) => {
  if (!text) return '';
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
};

const Aktuelle = () => {
  const [topNews, setTopNews] = useState([]);
  const [normalNews, setNormalNews] = useState([]);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/articles?populate=*`);
        // const res = await fetch("http://127.0.0.1:1337/api/articles?populate=*");
        const data = await res.json();
        if (!data.data) {
          console.error('No articles found in response');
          return;
        }
        const articles = data.data.map(item => ({
          id: item.id,
          title: item.title,
          body: item.haupt_text || [],
          slug: item.slug,
          createdAt: item.createdAt,
          updatedAt: item.updatedAt,
          publishedAt: item.publishedAt,
          isTop: item.isTop,
          cover: item.cover && item.cover.length > 0 
            ? item.cover.map(cover => ({
                id: cover.id,
                url: `${cover.url.startsWith('http') ? cover.url : `${process.env.REACT_APP_API_URL}${cover.url}`}`
              }))
            : [],
          // cover: item.cover && item.cover.length > 0
          //   ? item.cover.map(cover => ({
          //       id: cover.id,
          //       url: `${cover.url.startsWith('http') ? cover.url : `http://127.0.0.1:1337${cover.url}`}`
          //     }))
          //   : [],
          author: item.author ? {
            id: item.author.id,
            name: item.author.name,
            email: item.author.email
          } : null,
          category: item.category ? {
            id: item.category.id,
            name: item.category.name,
            slug: item.category.slug
          } : null,
          blocks: item.blocks
        }));
        setNormalNews(articles);
        setTopNews(articles.filter(a => a.isTop));
      } catch (err) {
        console.error('Error fetching articles:', err);
      }
    };

    fetchArticles();
  }, []);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    waitForAnimate: true
  };

  return (
    <div className="aktuelle-container1">
      <Helmet>
        <title>Stimmegeorgiens</title>
        <meta property="og:title" content="Stimme Georgiens - All Obedient Rhinoceros" />
      </Helmet>
      <Navigation />

      {/* Top News */}
      <section className="hero-news">
        {topNews.length > 0 && topNews[0]?.cover?.length > 0 && topNews.map(article => (
        <div className="aktuelle-thq-hero-news-container-elm hero-news-container" key={article.id}>
          <div className="hero-news-content">
            <span className="hero-news-badge">Top-Nachrichten</span>
            <h1 className="hero-title">{article.title}</h1>
            <div className="preview-text-top-news">
               <BlocksRenderer content={article.body} />
            </div>
            <div className="hero-news-author">{article.author?.name}</div>
            <Link to={`/news/${article.slug}`} className="btn btn-outline">
              Mehr Erfahren
            </Link>
          </div>
          {article.cover.length > 0 && (
            <div className="hero-news-media">
              <Slider key={topNews.length} {...sliderSettings}>
                {article.cover.map(image => (
                  <div key={image.id}>
                    <img src={image.url} alt={article.title} className="hero-news-image" />
                  </div>
                ))}
              </Slider>
            </div>
          )}
        </div>
        ))}
      </section>

      {/* Normal News */}
      <section className="blog-grid">
        <div className="blog-grid-wrapper">
          <h2 className="section-title">Neuigkeiten</h2>
          <div className="blog-grid-posts">
            {normalNews.map(article => (
              <article className="blog-grid-card" key={article.id}>
                {article.cover.length > 0 && (
                  <div className="blog-grid-card-image">
                    <Slider  key={article.id} {...sliderSettings}>
                      {article.cover.map(image => (
                        <div key={image.id}>
                          <img src={image.url} alt={article.title} className="blog-grid-image" />
                        </div>
                      ))}
                    </Slider>
                  </div>
                )}
                <div className="blog-grid-card-content">
                  <h3 className="blog-grid-card-title">{article.title}</h3>
                  <div className="preview-text">
                    <BlocksRenderer content={article.body} />
                  </div>
                  <div className="blog-grid-card-meta">
                    <span className="blog-grid-card-author">{article.author?.name}</span>
                  </div>
                  <Link to={`/news/${article.slug}`} className="btn btn-outline">
                    Mehr Erfahren
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Aktuelle;
